import { AppStorage } from '../../service/UserStorage';

import * as languages from './languages.json';

const locale = 'vi';

export function translate(errorCode, message = null): string {
  if (errorCode) {
    if (errorCode.includes && errorCode.includes('+')) {
      let result = '';
      errorCode.split('+').forEach((item) => {
        result += ` ${translate(item, message)}`;
      });
      return result.trim();
    } else {
      if (languages[errorCode] && languages[errorCode][locale] !== undefined) {
        return languages[errorCode][locale];
      } else if (message) {
        return message;
      }
    }
  }
  return errorCode;
}


let localization;

export function translateError(response): string {
  let errors, message;
  if (typeof response === 'object') {
    if (response && response.data && response.data.error) {
      if (response.data.error.code === '9999') {
        message = response.data.error.message;
      } else if (response.data.error.validationErrors && response.data.error.validationErrors.length) {
        let messages = [];
        response.data.error.validationErrors.forEach(validationError => {
          if (validationError.message) {
            messages.push(validationError.message);
          }
        });
        if (messages.length) {
          message = messages.join(', ');
        }
      } else if (response.data.error.code) {
        errors = 'ErrorCode-' + response.data.error.code;
      }
    }
  } else {
    errors = response;
  }
  console.log(errors)
  if (errors) {
    if (localization) {
      console.log(localization)
      if (errors && localization[errors]) {
        return localization[errors];
      }
    } else {
      try {
        localization = JSON.parse(AppStorage.get('localization'));
        console.log(localization);
        return localization[errors];
      } catch (e) {
      }
    }
  } else {
    return message || 'Có lỗi xảy ra. Vui lòng kiểm tra lại nghiệp vụ';
  }
}